import axios from 'axios';
import pckg from '../package.json';


export default class StashAPI {

  getAuthToken() {
    return window.localStorage.getItem('authToken');
  }

  setAuthToken(token) {
    return window.localStorage.setItem('authToken', token);
  }

  getConfig() {
    const authToken = this.getAuthToken();
    return {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    }
  }

  getUrl(url, params=null) {
    let _url = url;
    if (params) {
      let sep = '?';
      let value = null;
      for (const name of Object.keys(params)) {
        value = params[name];
        if (value) {
          _url += `${sep}${name}=${value}`;
          sep = '&';
        }
      }
    }
    return _url;
  }

  authGET(url, params=null) {
    return axios.get(
      this.getUrl(url, params), this.getConfig()
    ).catch(error => {
      if (error.response.status === 401) {
        window.localStorage.removeItem('authToken');
      }
      return Promise.reject(error);
    });
  }

  authPOST(url, payload, params=null) {
    return axios.post(
      this.getUrl(url, params), payload, this.getConfig()
    ).catch(error => {
      if (error.response.status === 401) {
        window.localStorage.removeItem('authToken');
      }
      return Promise.reject(error);
    });
  }

  authDELETE(url, params=null) {
    return axios.delete(
      this.getUrl(url, params), this.getConfig()
    ).catch(error => {
      if (error.response.status === 401) {
        window.localStorage.removeItem('authToken');
      }
      return Promise.reject(error);
    });
  }

  getUserDetails() {
    const { apiRoot } = pckg;
    return this.authGET(`${apiRoot}/profile/`);
  }

  getMolecules(feed='latest', limit=20, offset=0, tags=null, q=null) {
    const { apiRoot, pageLimit } = pckg;
    return this.authGET(`${apiRoot}/molecules/`, {
      q,
      feed,
      offset,
      limit: pageLimit || limit,
      tags: JSON.stringify(tags || []),
    });
  }

  getMoleculeDetails(fp) {
    const { apiRoot } = pckg;
    const full = window.localStorage.getItem('fullDetails');
    return this.authGET(
      `${apiRoot}/molecules/${fp}/`, full ? {full: true} : null
    );
  }

  getTagsForMolecule(fp) {
    const { apiRoot } = pckg;
    return this.authGET(`${apiRoot}/molecules/${fp}/tags/`);
  }

  getSuggestedTags(searchTerm) {
    const { apiRoot } = pckg;
    return this.authGET(`${apiRoot}/tags/`, {q: searchTerm});
  }

  searchMolecules(q, limit=20, offset=0) {
    const { apiRoot, searchPageLimit } = pckg;
    return this.authGET(`${apiRoot}/molecules/`, {
      q,
      offset,
      limit: searchPageLimit || limit,
    });
  }

  createMolecule(moleculeType, data) {
    const { apiRoot } = pckg;
    return this.authPOST(`${apiRoot}/molecules/`, {
      molecule_type: moleculeType,
      payload: data
    });
  }

  deleteMolecule(fp, purge=false) {
    const { apiRoot } = pckg;
    return this.authDELETE(
      `${apiRoot}/molecules/${fp}/`, purge ? {purge: true} : null
    );
  }

  restoreMolecule(fp) {
    const { apiRoot } = pckg;
    return this.authPOST(`${apiRoot}/molecules/${fp}/restore/`);
  }

  createTagOnMolecule(moleculeFp, tagName) {
    const { apiRoot } = pckg;
    return this.authPOST(`${apiRoot}/molecules/${moleculeFp}/tags/`, {
      name: tagName
    });
  }

  removeTagOnMolecule(moleculeFp, tagFp) {
    const { apiRoot } = pckg;
    return this.authDELETE(
      `${apiRoot}/molecules/${moleculeFp}/tags/${tagFp}/`
    );
  }

}



// WEBPACK FOOTER //
// ./src/StashAPI.js